import { RootState } from 'src/types/RootState';

export function getIsSuccess(state: RootState): boolean {
  return state.saveProject.status?.state === 'success';
}
